const messages = {
  "accountBox": {
    "title": "Dashboard",
    "description": "Volg snel en eenvoudig uw acties en puntensaldo op.",
    "button": "DASHBOARD OPENEN"
  }
};

export default {
  messages,
};
